import {Modal} from "@mui/material";
import React, {useEffect, useState} from "react";
import TopBar from "../../components/Layout/TopBar";
import MyButton from "../../components/Layout/MyButton";
import {faFileDownload, faXmark} from "@fortawesome/free-solid-svg-icons";
import {useAlert} from "react-alert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf} from "@fortawesome/free-regular-svg-icons";
import {useNavigate} from "react-router";
import {URL_API} from "../../utils/globalConfig";
import {downloadFile} from "../../utils/downloadHelper";
import axios from "axios";
import {logError} from "../../components/Utils/FormatData";

const css = {
	container: {height: '60%', width: '40%', backgroundColor: 'white', borderRadius: '5px'},
	fullRow: {height: '100%', width: '100%', alignItems: 'center'},
	row: {height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal'},
	rowValidation: {height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end'},
	contractBtn: {
		color: 'rgb(255, 255, 255)',
		height: '50%',
		backgroundColor: '#0094CA',
		width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '10px',
		cursor: 'pointer',
	},
	contractBtnIcon: {fontSize: "50px"},
	contractBtnLabel: {
		textAlign: 'center',
		textDecoration: 'none',
		fontSize: 14,
		fontWeight: 700,
		margin: '10px',
		cursor: 'pointer'
	}
}

const ModalViewAgreements = (props) => {
	const {openModal, setOpenModal, color, dossier, user, profil, contractId} = props;
	const alert = useAlert();
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();

	// region function

	const onRequestPassAgreementBtnClick = () => {
		navigate(`/demande-passage/accords-principe?id=${dossier.id}`);
	}
	const handleCloseModal = () => {
		setIsLoading(false);
		setOpenModal(false);
	};

	// endregion

	// region API

	//#endregion

	return(<>
		<Modal open={openModal} style={{display: 'flex'}} disableEscapeKeyDown={true}>
			<div className='modal'>
				<div style={css.container}>
					<TopBar title={`Accords de principe du dossier [N°${dossier.id}]`} className='topbar-contenu' color={color}
									buttons={<div className='topbar-buttons'>
										<MyButton onClick={() => handleCloseModal()} label="Fermer" icon={faXmark}/>
									</div>}
					/>
					<div style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-around',
						alignItems: 'center',
						height: '90%',
						width: '100%'
					}}>
						{(profil.profil === 1 || profil.profil === 2) &&
						<div className="icon-opacity" style={css.contractBtn} title={"Créer accords de principe"}
								 onClick={onRequestPassAgreementBtnClick}>
							<FontAwesomeIcon style={css.contractBtnIcon} icon={faFilePdf} />
							<label style={css.contractBtnLabel}>{"Créer"}</label>
						</div>
						}

						{(profil.profil === 1 || profil.profil === 2 || profil.profil === 3 || profil.profil === 5) && contractId &&
						<a className="icon-opacity" style={{...css.contractBtn, cursor: 'pointer'}} title={"Télécharger les accords de principe"}
							 onClick={() => downloadFile(URL_API + '/demande-passage/telecharger-accords-principe?requestId=' + props.dossier.id)}>
							<FontAwesomeIcon style={css.contractBtnIcon} icon={faFileDownload} />
							<label style={css.contractBtnLabel}>{"Télécharger"}</label>
						</a>}

					</div>
				</div>
			</div>
		</Modal>
	</>)
}

export default ModalViewAgreements;